import * as a from '@mitranim/js/all.mjs'
import * as c from './conf.mjs'
import * as um from './util-misc.mjs'
import * as uma from './util-math.mjs'

const DISK_KEY_BITS = `bits`

export class Disk extends um.Enved {
  get Bank() {return Bank}
  makeBank(src) {return new this.Bank(src).setParent(this)}
  bank() {return this.makeBank(this.read())}
  // Override in subclass.
  read() {}
  write() {}
}

/*
Caution. This must never be used to store identifying information such as user
id, session id, and so on. Cookie data can be edited and faked. The current
implementation does not authenticate the data. Identifying information must be
derived from the session id cookie via client-server request.

Caution. Cookie size is limited to 4096 bytes in common browsers. We must
carefully limit the size of this data, AND we must cleanup unused entries.
*/
export class CookieDisk extends Disk {
  read() {return a.jsonDecode(this.env.cook.getVal(this.key()))}
  write(val) {this.env.cook.setVal(this.key(), a.jsonEncode(val))}
  key() {return c.COOKIE_NAME_DATA}
}

// App data stored on disk. TODO better name.
export class Bank extends a.MixChild(a.CompatMap) {
  setParent(val) {return super.setParent(a.reqInst(val, Disk))}
  reqKey(key) {return a.reqValidStr(key)}
  delete(key) {return super.delete(key), this}
  write() {return this.getParent().write(this), this}

  /*
  Writes the given key to the disk if it is not already present. Returns `false`
  if key was previously written and `true` if not.
  */
  wroteMissing(key, val) {
    return !this.get(key) && (this.set(key, val).write(), true)
  }

  bits() {return this.get(DISK_KEY_BITS)}
  bitsSet(val) {return this.set(DISK_KEY_BITS, a.optNat(val))}
  bitsHas(mask) {return uma.bitsHas(this.bits(), mask)}
  bitsAdd(mask) {return this.bitsSet(uma.bitsAdd(this.bits(), mask))}
  bitsDel(mask) {return this.bitsSet(uma.bitsDel(this.bits(), mask))}
  bitsSwitch(mask, ok) {return ok ? this.bitsAdd(mask) : this.bitsDel(mask)}

  // Returns true if the bits were modified and stored, and false otherwise.
  wroteMissingBits(mask) {
    const prev = this.bits()
    const next = uma.bitsAdd(prev, mask)
    return prev !== next && (this.bitsSet(next).write(), true)
  }
}

export function diskMigrate(_env) {}

// Throttles promotion nagging.
export function diskAllowPromoNag(ctx) {
  const bank = ctx.env.disk.bank()
  const timeNow = Date.now()
  const timeMax = a.laxFin(bank.get(c.DISK_KEY_PROMO_NAGGED_AT)) + a.secToMs(c.PROMO_NAG_PERIOD_SEC)
  const countPrev = a.optFin(bank.get(c.DISK_KEY_PROMO_NAG_COUNTDOWN)) ?? c.PROMO_NAG_COUNTDOWN
  const countNext = Math.max(countPrev - 1, 0)

  if (timeNow > timeMax && !countNext) {
    bank.set(c.DISK_KEY_PROMO_NAGGED_AT, timeNow)
    bank.set(c.DISK_KEY_PROMO_NAG_COUNTDOWN, c.PROMO_NAG_COUNTDOWN)
    bank.write()
    return true
  }

  if (countPrev) {
    bank.set(c.DISK_KEY_PROMO_NAG_COUNTDOWN, countNext)
    bank.write()
  }
  return false
}
